import {createReducer} from "typesafe-actions";
import {HostPort} from "../../../models/api/codegen/code";
import {getBannerHostPortAsync} from "../actions";

const initialValue = null;

export const bannerHostPortReducer = createReducer<HostPort | null>(initialValue)
    .handleAction(getBannerHostPortAsync.success, (state, action) => action.payload);
